<script lang="ts">
  import NavItemLinkSM from "../NavItemLinkSM/NavItemLinkSM.svelte";
  import type { NavItem, PromoImage as PImage } from "$lib/gql/genCms/codegen";
  import PromoImage from "../NavPromoImage/NavPromoImage.svelte";
  import { createEventDispatcher } from "svelte";

  export let navItems: NavItem[];
  export let viewAllPath: string = "";
  export let primaryRoute = false;
  export let promoImage: PImage;
  export const dispatch = createEventDispatcher();

  function onImageClick() {
    dispatch("toggleMobileNav");
  }
</script>

<style lang="scss">
  .nav-link-list {
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }

    &--item {
      border-top: 1px solid $background;
      padding: 9px 0px;

      &__hidden {
        display: none;
      }
    }
  }
</style>

{#if navItems}
  <div class="nav-link-list">
    {#each navItems as navItem}
      {#if !navItem.hidden}
        <div
          class={`nav-link-list--item ${
            navItem.hidden && "nav-link-list--item__hidden"
          }`}
        >
          <NavItemLinkSM
            on:routeSelect
            on:toggleMobileNav
            {navItem}
            {primaryRoute}
          />
        </div>
      {/if}
    {/each}
    {#if viewAllPath !== ""}
      <div class="nav-link-list--item">
        <NavItemLinkSM
          on:toggleMobileNav
          {viewAllPath}
          {primaryRoute}
          lastRoute={primaryRoute
            ? false
            : navItems.filter(navItem => navItem.items && navItem.items)
                .length === 0}
        />
      </div>
    {/if}
  </div>
{/if}

{#if promoImage}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="nav-link-list--image"
    on:click={onImageClick}
    on:keydown={onImageClick}
  >
    <PromoImage {promoImage} />
  </div>
{/if}
